import {
  TrustedSection,
  MarqueeContainer,
  MarqueeContent,
  MarqueeItem,
  TrustedSectionImg,
} from "../../styles/homeComp/trustedStyles";

const TrustedComponent = () => {
  return (
    <TrustedSection>
      <h1> Trusted by engineers at </h1>
      <div className=" marque_container">
        <MarqueeContainer>
          <MarqueeContent>
            {trustedCard.map((item, index) => (
              <MarqueeItem key={index}>
                <TrustedSectionImg
                  src={item.src}
                  alt="icon"
                  imgHeight={item.imgHeight}
                  imgWidth={item.imgWidth}
                  mobileHeight={item.mobileHeight}
                />
              </MarqueeItem>
            ))}
          </MarqueeContent>
        </MarqueeContainer>
        <div className="alt_text">
          <div>
                      <p>Powering teams inside the world’s most innovative companies.</p>


          </div>
        </div>
      </div>
    </TrustedSection>
  );
};
export default TrustedComponent;

export const trustedCard = [
  {
    src: "/images/amazon.png",
    imgHeight: "60px",
    imgWidth: "160px",
    mobileHeight: "45px",
  },
  {
    src: "/images/netflix2.png",
    imgHeight: "40px",
    imgWidth: "165px",
    mobileHeight: "40px",
  },
  {
    src: "/images/airbnb.png",
    imgHeight: "45px",
    imgWidth: "130px",
    mobileHeight: "40px",
  },

  {
    src: "/images/tesla.png",
    imgHeight: "80px",
    imgWidth: "200px",
    mobileHeight: "40px",
  },
  {
    src: "/images/mono_logo.png",
    imgHeight: "30px",
    imgWidth: "180px",
    mobileHeight: "45px",
  },
  {
    src: "/images/github logo.png",
    imgHeight: "50px",
    imgWidth: "50px",
    mobileHeight: "45px",
  },
  {
    src: "/images/ingressive.png",
    imgHeight: "45px",
    imgWidth: "200px",
    mobileHeight: "",
  },
  {
    src: "/images/netflix2.png",
    imgHeight: "40px",
    imgWidth: "165px",
    mobileHeight: "40px",
  },
];
